import { mapActions, mapGetters } from 'vuex';

export const kz = {
  computed: {
    ...mapGetters({
      isFlutterReady: 'flutter/isFlutterReady'
    }),
    isCz() {
      return this.$domainRegion === 'cz';
    },
    isSk() {
      return this.$domainRegion === 'sk';
    },
    isUaRu() {
      return ['uk', 'ru'].includes(this.$i18n.locale);
    },
    isHu() {
      return this.$domainRegion === 'hu';
    },
    genderList() {
      return [
        {
          id: 1,
          value: this.$t('preventionForm.gender.male')
        },
        {
          id: 2,
          value: this.$t('preventionForm.gender.female')
        },
        {
          id: 3,
          value: this.$t('preventionForm.gender.other')
        }
      ];
    },
    genderAwareIcon() {
      switch (this.$auth?.user?.gender) {
        case 1:
          return 'male';
        case 2:
          return 'female';
        default:
          return 'universal';
      }
    },
    allowUser() {
      return (
        !!this.$auth.user &&
        !!this.$auth.user.email &&
        !!this.$auth.user.email.length &&
        !!this.$auth.user.legalDocuments &&
        !!this.$auth.user.legalDocuments.length
      );
    },
    webuserRegion() {
      switch (this.$auth?.user?.regionId) {
        case 2:
          return 'SK';
        case 3:
          return 'HU';
        default:
          return 'CZ';
      }
    }
  },
  methods: {
    ...mapActions({
      updateFormDialogs: 'dynamicForms/updateFormDialogs'
    }),
    openLoginDialog() {
      if (this.$auth.isLoggedIn) {
        this.$router.push(this.$localePath({ name: 'dashboard', params: { savePosition: true } }));
        return false;
      } else {
        this.$router.push(
          this.$localePath({
            name: this.currentPath,
            query: { loginDialog: 'registration' },
            params: { savePosition: true }
          })
        );
        this.$eventHub.$emit('toggleLoginDialog', true);
      }
    },
    async logout(params = 'registration') {
      this.$store.state.general.cancelToken?.cancel();
      this.$store.commit('general/setCancelToken', null);
      await this.$auth.logout().finally(async () => {
        if (this.isFlutterReady) {
          window.flutter_inappwebview.callHandler('onLogout');
        }
        await this.$router.push(this.$localePath(params));
      });
    },
    needAdviceClick() {
      this.gtmPush({ event: 'button_click', 'button.type': this.$t('dashboard.needAdvice') });
      this.$router.push(this.$localePath('questions'));
    },
    needAppointmentClick() {
      this.gtmPush({
        event: 'button_click',
        'button.type': this.$t('dashboard.needAppointment')
      });
      this.$router.push(this.$localePath('appointments'));
    }
  }
};
